import React from "react";
import MenuButton from "./MenuButton";
import "../../css/menu.css";
import AbstractMenu from "./AbstractMenu";
import SubmenuHeader from "./SubMenuHeader";
import AI from "../../admin/AI/AI";
import { Route, Switch } from "react-router-dom";
import { I18n } from "react-redux-i18n";
import Meals from "../../admin/meals/Meals";
import Drinks from "../../admin/drinks/Drinks";
import Restaurants from "../../admin/Restaurants";
import Printers from "../../admin/Printers";
import ProductionLines from "../../admin/ProductionLines";
import Tables from "../../admin/Tables";
import VatCategories from "../../admin/VatCategories";
import QuantityTypes from "../../admin/QuantityTypes";
import DiscountTypes from "../../admin/DiscountTypes";
import Labels from "../../admin/Labels";
import Customers from "../../admin/Customers";
import CashRegisters from "../../admin/CashRegisters";
import Scales from "../../admin/Scales";
import TableLayouts from "../../admin/TableLayouts";
import Wolt from "../../admin/Wolt";
import auth, { featureEnabled, messageDialog, startpoll } from "../../js/auth";
import UpdateSettingButton from "../../components/menus/UpdateSettingButton";
import Advertisements from "../../admin/Advertisements";
import FoodPanda from "../../admin/FoodPanda";
import ChoiceQR from "../../admin/ChoiceQR";
import admin from "../../js/admin";
import PlansMenu from "./PlansMenu";
import BankTerminals from "../../admin/BankTerminals";
import Falatozz from "../../admin/Falatozz";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { store } from "../..";
import EatWithMeActions from "../../actions/EatWithMeActions";
import CanAccess from "../CanAccess";

class AdminMenu extends AbstractMenu {
  state = { warningShown: false };

  componentWillUnmount = () => {
    admin.getMyStatus(() => { });
  }

  ntakCheck = () => {
    if (!featureEnabled("ntak"))
      return;
    if (this.props.myStatus.roles && !this.state.warningShown) {
      const ntakConnectionOK = this.props.myStatus?.ntakstatus?.status?.connectionOK;
      this.setState({ warningShown: true });
      admin.getActiveMenuItems(data => {
        function checkNtak(category) {
          if (category.activeMenuItems.find(m => m.isActive && m.isTop && (!m.defaultMainCategoryId || !m.defaultSubCategoryId))) {
            return true;
          }
          if (category.activeMenuCategories.filter(m => m.isActive && m.isTop).find(checkNtak)) return true;
        }
        const drinkproblem = data.activeMenuCategories.filter(m => m.isActive && m.isTop && m.entityType === "DrinkCategory").find(checkNtak);
        const mealproblem = data.activeMenuCategories.filter(m => m.isActive && m.isTop && m.entityType === "MealCategory").find(checkNtak);
        this.setState({ ntakProblem: !ntakConnectionOK, mealNtakProblem: mealproblem, drinkNtakProblem: drinkproblem });
      })
    }
  }

  componentDidMount = () => {
    this.ntakCheck();
    if (this.props?.myStatus?.sessionId) startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);
  }

  componentDidUpdate = () => {
    this.ntakCheck();
    if (this.props?.myStatus?.sessionId) startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);
  }

  componentWillUnmount = () => {
    admin.getActiveMenuItems(data => {
      store.dispatch(EatWithMeActions.menuCategories(data.activeMenuCategories));
    });
  }


  render() {
    const background = "#847556";
    if (this.props.myStatus.restaurant_id) {
      return (
        <Switch>
          <Route
            path={"/adminMenu"}
            render={props => (
              <div className="mainMenuWrap" style={{ flexGrow: 1, display: "flex", flexFlow: "column" }}>
                <SubmenuHeader {...this.props} header={I18n.t("admin_local.menus.administration")} />
                <CanAccess resource="administration">
                  <div className="mainMenuGrid" style={{ flexGrow: 1 }}>
                    <CanAccess resource="administration.restaurants">
                      <MenuButton backgroundImage={require("../../img/menu-new/settings.svg")} error={this.state.ntakProblem} href="adminMenu/restaurants" myStatus={this.props.myStatus} i="i_system_parameter" background={background} name={I18n.t("admin_local.menus.restaurants")} >
                        {!this.state.ntakProblem ? null : <i className="icon-attention" style={{ color: "yellow", animation: "opacity 3s infinite steps(10)" }} />}
                      </MenuButton>
                    </CanAccess>
                    <CanAccess resource="administration.rbac">
                      <MenuButton backgroundImage={require("../../img/menu-new/users.svg")} href="adminMenu/rbac" myStatus={this.props.myStatus} i="i_system_parameter" background={background} name={I18n.t("admin_local.menus.rbac")} />
                    </CanAccess>
                    <CanAccess resource="administration.products.*">
                      <MenuButton backgroundImage={require("../../img/menu-new/drinks-admin.svg")} error={this.state.drinkNtakProblem} href="adminMenu/drinks" myStatus={this.props.myStatus} i="i_wine" background={background} name={I18n.t("admin_local.menus.drinks")} >
                        {!this.state.drinkNtakProblem ? null : <i className="icon-attention" style={{ color: "yellow", animation: "opacity 3s infinite steps(10)" }} >ntak</i>}
                      </MenuButton>
                    </CanAccess>
                    <CanAccess resource="administration.products.*">
                      <MenuButton backgroundImage={require("../../img/menu-new/meals-admin.svg")} error={this.state.mealNtakProblem} href="adminMenu/meals" myStatus={this.props.myStatus} i="i_food" background={background} name={I18n.t("admin_local.menus.meals")}>
                        {!this.state.mealNtakProblem ? null : <i className="icon-attention" style={{ color: "yellow", animation: "opacity 3s infinite steps(10)" }} >ntak</i>}
                      </MenuButton>
                    </CanAccess>
                    <CanAccess resource="administration.tables">
                      <MenuButton backgroundImage={require("../../img/menu-new/table-overview-map.svg")} href="adminMenu/tables" myStatus={this.props.myStatus} i="i_table" background={background} name={I18n.t("admin_local.menus.tables")} />
                    </CanAccess>
                    <CanAccess resource="administration.productionlines">
                      <MenuButton backgroundImage={require("../../img/menu-new/kitchen.svg")} href="adminMenu/production-lines" myStatus={this.props.myStatus} i="i_production" background={background} name={I18n.t("admin_local.menus.productionLines")} />
                    </CanAccess>
                    <CanAccess resource="administration.vatcategories">
                      <MenuButton backgroundImage={require("../../img/menu-new/bar-chart-2.svg")} href="adminMenu/vatCategories" myStatus={this.props.myStatus} i="i_system_parameter" background={background} name={I18n.t("admin_local.menus.VATCategories")} />
                    </CanAccess>
                    <CanAccess resource="administration.printers">
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-printer.svg")} href="adminMenu/printers" myStatus={this.props.myStatus} i="icon-printer" background={background} name={I18n.t("admin_local.menus.printers")} />
                    </CanAccess>
                    <CanAccess resource="administration.cashregisters">
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-cash-register.svg")} href="adminMenu/cashRegisters" myStatus={this.props.myStatus} i="i_cash_register" background={background} name={I18n.t("admin_local.menus.cashRegisters")} />
                    </CanAccess>
                    <CanAccess resource="administration.bankterminals">
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-bank-terminal.svg")} href="adminMenu/bankTerminals" myStatus={this.props.myStatus} i="i_cash_register" background={background} name={I18n.t("admin_local.menus.bankTerminals")} />
                    </CanAccess>
                    <CanAccess resource="administration.scales">
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-scale.svg")} href="adminMenu/scales" myStatus={this.props.myStatus} i="i_scale" background={background} name={I18n.t("admin_local.menus.scales")} />
                    </CanAccess>
                    <CanAccess resource="administration.servings">
                      <MenuButton backgroundImage={require("../../img/menu-new/package.svg")} href="adminMenu/servings" myStatus={this.props.myStatus} i="i_system_parameter" background={background} name={I18n.t("admin_local.menus.servings")} />
                    </CanAccess>
                    <CanAccess resource="administration.discounts">
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-percent.svg")} href="adminMenu/discounts" myStatus={this.props.myStatus} i="icon-percent" background={background} name={I18n.t("admin_local.menus.discounts")} />
                    </CanAccess>
                    <CanAccess resource="administration.advertisements">
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-image.svg")} href="adminMenu/advertisements" myStatus={this.props.myStatus} i="icon-picture" background={background} name={I18n.t("admin_local.menus.advertisements")} />
                    </CanAccess>
                    <CanAccess resource="administration.labels">
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-tag.svg")} href="adminMenu/labels" myStatus={this.props.myStatus} i="i_label" background={background} name={I18n.t("admin_local.menus.labels")} />
                    </CanAccess>
                    <CanAccess resource="administration.customers">
                      <MenuButton backgroundImage={require("../../img/menu-new/users.svg")} href="adminMenu/customers" myStatus={this.props.myStatus} roles={["superadmin"]} i="i_user" background={background} name={I18n.t("admin_local.menus.customers")} />
                    </CanAccess>
                    <CanAccess resource="administration.wolt">
                      <MenuButton backgroundImage={require("../../img/wolt.png")} features={["wolt"]} href="adminMenu/wolt" myStatus={this.props.myStatus} i="icon-wolt" background={background} name={I18n.t("admin_local.menus.wolt")} />
                    </CanAccess>
                    <CanAccess resource="administration.foodpanda">
                      <MenuButton backgroundImage={require("../../img/foodpanda.png")} features={["foodpanda"]} href="adminMenu/foodpanda" myStatus={this.props.myStatus} i="icon-foodpanda" background={background} name={I18n.t("admin_local.menus.foodpanda")} />
                    </CanAccess>
                    <CanAccess resource="administration.falatozz">
                      <MenuButton backgroundImage={require("../../img/falatozz.png")} features={["falatozz"]} href="adminMenu/falatozz" myStatus={this.props.myStatus} i="icon-falatozz" background={background} name={I18n.t("admin_local.menus.falatozz")} />
                    </CanAccess>
                    <CanAccess resource="administration.choiceqr">
                      <MenuButton backgroundImage={require("../../img/choiceqr.png")} features={["choiceqr"]} href="adminMenu/choiceqr" myStatus={this.props.myStatus} i="icon-choiceqr" background={background} name={I18n.t("admin_local.menus.choiceqr")} />
                    </CanAccess>
                    {auth?.device?.platform !== "browser" && <UpdateSettingButton backgroundImage={require("../../img/menu-new/settings.svg")} myStatus={this.props.myStatus} background={background} name={I18n.t("admin_local.menus.updateSettings")} />}                 : 
                  </div>
                </CanAccess>
              </div>
            )}
          />
        </Switch>
      );
    }
    else return null;
  }
}

const mapStateToProps = state => {
  return {
    admin_local: state.rootReducer.admin_local,
    local: state.rootReducer.local,
    myStatus: state.rootReducer.myStatus,
  };
};

export default connect(mapStateToProps)(withRouter(AdminMenu));
